import Main from "../pages/Main";

export const routes = [
    // { path: '*', component: <NotFound/>, exact: false },
    { path: '/', component: <Main/>, exact: true },
    { path: '/offerta.pdf' },
]